module.exports = __webpack_public_path__ + "static/media/bug-yellow.ab6d0362.svg";